import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Close } from "../../../assets/images/close.svg";

import { ForgotPasswordForm } from "./ForgotPasswordForm";

import "./ForgotPassword.scss";

export function ForgotPassword() {
  return (
    <div className="forgot-password-component">
      <div className="layout-container">
        <Link to="/">
          <Close className="close-button" />
        </Link>
        <div className="content-container">
          <div className="title">Reset Password</div>

          <ForgotPasswordForm />

          <div className="login-container">
            <div className="already-text">Remember your password?</div>
            <Link to="/auth/login" className="login-link">
              <div className="login-text">Back to login</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
